import {Component, Inject, OnInit} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";

const password = new FormControl('', Validators.required);
const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'app-form-validation',
  templateUrl: './form-validation.component.html',
  styleUrls: ['./form-validation.component.scss']
})
export class FormValidationComponent implements OnInit {
  public form: FormGroup = Object.create(null);
  dynamicForm: FormGroup = Object.create(null);
  keys: any[] = [];
  exampleDatabase: ExampleHttpDatabase | null = null;

  constructor(private fb: FormBuilder,  public dialogRef: MatDialogRef<FormValidationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private _httpClient: HttpClient) { }
  ngOnInit() {
    this.exampleDatabase = new ExampleHttpDatabase(this._httpClient);
    if (this.dynamicForm) {

      this.dynamicForm = Object.create(null);
    }

    //this.dynamicForm = undefined;
    let _json = {};

    console.log(this.data.dataForm);
    Object.keys(this.data.dataForm).map((rank, i, row) => {
      if(!(rank in this.data.hidenObj)) {
        this.keys.push(rank);

        let dis = (!(rank in this.data.disableObj))?false:true;
        if (dis) {
          dis = (this.data.dataForm[rank] == '') ? false : true;
        }
        // @ts-ignore
        _json[rank] = [{value: this.data.dataForm[rank], disabled: dis}
          , this.convertValid(row),
        ];
      }
    });

    this.dynamicForm = this.fb.group(_json);
      console.log(this.dynamicForm.controls);


  }
  onClickSubmit() {
    console.log(this.dynamicForm.controls);
    Object.keys(this.data.dataForm).map((rank, i, row) => {
      if(!(rank in this.data.hidenObj)) {
        console.log(rank, this.dynamicForm.controls[rank])
        this.data.dataForm[rank] = this.dynamicForm.controls[rank].value
      }
    });
    this.exampleDatabase!.guardar(this.data.dataForm, this.data.url).toPromise().then(data => {});
    this.dialogRef.close()
  }
  private convertValid(obj:any) {
      //todo: para obetner desde la bdd
    return Validators.compose([
      Validators.required
      /*Validators.minLength(1),
      Validators.maxLength()*/
    ])
     // return [Validators.required];

    }
  borrar(){
   const id =  this.data.dataForm[this.data.id]
    console.log(id)
    this.exampleDatabase!.delete(id, this.data.url).toPromise().then(data => {});
    this.dialogRef.close()
  }
}

export class ExampleHttpDatabase {
  constructor(private _httpClient: HttpClient) { }

  delete(id: string, href:string): Observable<any> {
    //const href = 'http://127.0.0.1:4000/productos/';
    const requestUrl =
        `${href}${id}`;

    return this._httpClient.delete<any>(requestUrl);
  }
  guardar(params: any, href:string): Observable<any> {
    //const href = 'http://127.0.0.1:4000/productos/';
    const requestUrl =
        `${href}`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this._httpClient.post<any>(requestUrl, JSON.stringify(params),httpOptions);
  }
}
